import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../store/auth/authSlice';

const Navbar = ({ onSidebarToggle, isSidebarOpen }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);

    const handleLogout = async () => {
        await dispatch(logoutUser());
        navigate('/login');
    };

    const handleEditProfile = () => {
        console.log('dsfdsfs', user?.id);
        navigate('/profile/edit/' + user?.id);
        return;
    };

    return (
        <nav className={`navbar navbar-expand-lg ${!isSidebarOpen ? 'expanded' : ''}`}>
            <div className="container-fluid">
                <div className="d-flex align-items-center">
                    {!isSidebarOpen && (
                        <button
                            className="menu-toggle sidebar-toggle"
                            onClick={onSidebarToggle}
                        >
                            <i className="fas fa-bars"></i>
                        </button>
                    )}
                    <span className="ms-3 text-muted">Welcome, {user?.name || 'A2Z Street'}</span>
                </div>

                <div className="d-flex align-items-center gap-3">
                    <div className="position-relative">
                        {/* <i className="fas fa-bell text-muted align-middle"></i>
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              2
            </span> */}
                    </div>

                    <div className="dropdown">
                        <button
                            className="btn btn-link nav-link p-0"
                            data-bs-toggle="dropdown"
                        >
                            <img
                                src="/images/avatar.jpg"
                                alt="User"
                                className="rounded-circle"
                                width="32"
                                height="32"
                            />
                        </button>

                        <div className="dropdown-menu dropdown-menu-end user-dropdown">
                            <div className="dropdown-header d-flex align-items-center p-3 border-bottom">
                                <div className="d-flex align-items-center">
                                    <img
                                        src="/images/avatar.jpg"
                                        alt="User"
                                        className="rounded-circle me-2"
                                        width="42"
                                        height="42"
                                    />
                                    <div>
                                        <h6 className="mb-0">{user?.name}</h6>
                                        <small className="text-muted">{user?.email}</small>
                                    </div>
                                </div>
                                <button onClick={handleLogout} className="btn btn-link ms-auto p-0 text-muted">
                                    <i className="fas fa-sign-out"></i>
                                </button>
                            </div>

                            <div className="dropdown-body p-2">
                                <button onClick={handleEditProfile} className="dropdown-item py-2">
                                    <i className="fas fa-user-edit me-2 text-muted"></i>
                                    Edit Profile
                                </button>
                                <button onClick={handleLogout} className="dropdown-item py-2">
                                    <i className="fas fa-sign-out-alt me-2 text-muted"></i>
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </nav>
    );
};

export default Navbar; 